import { Injectable } from '@angular/core';
import { HttpUtil } from '@shared/util/http.util';
import { NotificationsStatusDTO } from 'app/view/notifications/data/NotificationsStatusDTO';
import { Observable } from 'rxjs';
import { PageDTO } from '@data/common/pagination/PageDTO';
import { ApplicationConfig } from '@config/application.config';
import { map } from 'rxjs/operators';
import { NotificationDTO } from '../data/NotificationDTO';
import { ObjectUtil } from '@shared/util/object.util';
import { PageCriteriaDTO } from '@data/common/pagination/PageCriteriaDTO';

@Injectable({
  providedIn: 'root'
})
export class NotificationsApiService {
  constructor(private readonly httpUtil: HttpUtil) {
  }

  public getPage(criteria: PageCriteriaDTO): Observable<PageDTO<NotificationDTO>> {
    return this.httpUtil
      .get(`${ ApplicationConfig.apiUrl }/users/me/in-app-notifications/page`, criteria)
      .pipe(
        map(response => ObjectUtil.plainToInstanceFromExist(new PageDTO<NotificationDTO>(NotificationDTO), response))
      );
  }

  public remove(notificationId: number): Observable<void> {
    return this.httpUtil.delete(`${ ApplicationConfig.apiUrl }/users/me/in-app-notifications/${ notificationId }`);
  }

  public markNotificationsAsRead(notificationIds: number[]): Observable<void> {
    return this.httpUtil.post(`${ ApplicationConfig.apiUrl }/users/me/in-app-notifications/read`, notificationIds);
  }

  public getNotificationsStatus(): Observable<NotificationsStatusDTO> {
    return this.httpUtil
      .get(`${ ApplicationConfig.apiUrl }/users/me/notifications/status`, {}, {silentMode: true, ignoreError: true})
      .pipe(
        map(response => ObjectUtil.plainToInstance(NotificationsStatusDTO, response))
      );
  }
}
